import { Order } from '../../../shared/types';

/**
 * `wallet_user_order` exactly as the backend sends it.
 *
 * Identical to `Order` in every field but one. That is the finding, not a
 * shortcut: the plan expected seventeen fields to need normalising, and once the
 * column types were checked against the wire, sixteen of them already matched —
 * the interface had simply been declaring `string | number` where the database
 * has always sent one or the other.
 *
 * Nine call sites receive this shape: `/api/order` and `/api/connect`, the four
 * payment-provider endpoints (which proxy to PHP but answer from
 * `getUserOrderById`, so it really is the same row), and two inline
 * `apiClient.get` calls in SelectProduct and WaitScreen.
 */
export type OrderDto = Omit<Order, 'id'> & {
    /** `wallet_user_order.id` is `int NOT NULL`, so the wire sends a number. */
    id: number | null;
};

/**
 * The one conversion the boundary actually needs.
 *
 * An order id is a number in the database and an opaque string everywhere in the
 * app — it goes into route params, query strings and analytics. Converting once
 * here is what lets `Order.id` be honestly `string | null`; without it the
 * declared type is a lie that eighteen call sites paper over with implicit
 * coercion, and any future `order.id === someRouteParam` would silently be false.
 */
export const toOrder = (dto: OrderDto): Order => ({
    ...dto,
    id: dto.id === null || dto.id === undefined ? null : String(dto.id),
});
